import { render, staticRenderFns } from "./ABlank.vue?vue&type=template&id=b5c66ae6"
import script from "./ABlank.vue?vue&type=script&lang=js"
export * from "./ABlank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports